<template>
	<div class="save-bar-container">
		<div class="level">
			<div class="level-left">
				<div class="level-item">
					<o-button variant="success" icon-left="save" :disabled="saving" @click="Save">
						Save
					</o-button>
				</div>
				<div class="level-item">
					<o-button variant="primary" icon-left="pencil" :disabled="editing" @click="EditPage">
						Edit Page
					</o-button>
				</div>
				<div class="level-item">
					<o-button icon-left="history" variant="warning" @click="Revert">Revert</o-button>
				</div>
				<div class="level-item">
					<o-button icon-left="trash" variant="danger" @click="Delete">Delete</o-button>
				</div>
			</div>
			<div class="level-right">
				<div class="level-item">
					<o-input
						v-model="internalName"
						icon-right="copy"
						@click="CopyToClipboard"
						readonly></o-input>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { ref, inject } from "vue";
	import editPageModalComponent from "@/components/modals/editPageModal.vue";

	export default {
		props: {
			uuid: {
				type: String,
				default: undefined
			},
			vueRouterName: {
				type: String,
				default: undefined
			}
		},
		emits: ["revert", "save", "editted", "delete"],
		setup(props, context) {
			const $oruga = inject("$oruga");
			const $http = inject("$http");
			const $error = inject("$error");
			const $success = inject("$success");
			const $confirm = inject("$confirm");

			const saving = ref(false);
			const editing = ref(false);

			const internalName = ref(props.vueRouterName);

			const EditPage = async () => {
				editing.value = true;

				try {
					const response = await $http.get("/api/v2/routes/" + props.uuid);
					if (response != null) {
						$oruga.modal.open({
							parent: self,
							component: editPageModalComponent,
							trapFocus: true,
							props: {
								uuid: props.uuid,
								metadata: response.data
							},
							events: {
								save: async (result) => {
									//TODO: Try Save MetaImage afterwards.
									try {
										await $http.post("/api/v2/routes", result.metadata);
										if (result.metadata.MetaImage?.OID) {
											//TODO: Needs testing
											await $http.post(
												"/api/v2/page/" +
													result.metadata.UUID +
													"/metaImage/" +
													result.metadata.MetaImage.OID +
													"?type=" +
													result.metadata.MetaImage.Type.Identifier
											);
										}
										context.emit("editted", { editing: editing, route: result.metadata });

										result.close();
									} catch (err) {
										$error("An issue occurred saving the page. Please try again.");
										console.error(err);
									}
								},
								close: () => {
									editing.value = false;
								}
							}
						});
					}
				} catch (err) {
					$error("An issue occurred getting page information. Please try again.");
					editing.value = false;
				}
			};

			const Save = () => {
				context.emit("save", { saving: saving });
			};

			const Revert = () => {
				context.emit("revert");
			};

			const Delete = () => {
				$confirm({
					title: "Delete Page",
					message: "Are you sure you want to remove this page and all sections on it?",
					onConfirm: () => {
						context.emit("delete");
					}
				});
			};

			const CopyToClipboard = () => {
				navigator.permissions.query({ name: "clipboard-write" }).then((result) => {
					if (result.state === "granted" || result.state === "prompt") {
						navigator.clipboard.writeText(internalName.value).then(
							() => {
								$success("Copied to clipboard: " + internalName.value);
							},
							() => {
								$error("Cannot copy to clipboard");
							}
						);
					}
				});
			};

			return {
				saving,
				editing,
				internalName,
				CopyToClipboard,
				EditPage,
				Save,
				Revert,
				Delete
			};
		}
	};
</script>

<style lang="scss" scoped>
	@import "@/assets/css/globalVars.scss";

	.save-bar-container {
		border: solid 1px $boyden-blue;
		background: #fff;
		box-shadow: 5px 5px 5px 5px rgba(0, 0, 0, 0.5);
		position: sticky;
		bottom: -2rem;
		padding: 1rem 1.875rem;
		z-index: 5;
	}
	.save-bar {
		display: flex;

		flex-direction: row;
		gap: 0.4rem;
		z-index: 1;
	}
</style>
